import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { ProgressDialog } from '@yola/ws-ui';

const defaultCaptions = {};

function ImageLoadingDialog({ captions = defaultCaptions, ...restProps }) {
  const getCaptions = (captionsOverrides) => ({
    title: `${i18next.t('Uploading image')}...`,
    description: i18next.t('Your image will be uploaded to the website soon'),
    cancel: i18next.t('Cancel'),
    ...captionsOverrides,
  });

  return (
    <ProgressDialog
      overlay="visible"
      progressType="indeterminate"
      cancelable={false}
      captions={getCaptions(captions)}
      {...restProps}
    />
  );
}

ImageLoadingDialog.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    cancel: PropTypes.string,
  }),
};

export default ImageLoadingDialog;
